// Account deletion by request. Sending a request deletes nothing: a person on
// the team runs the deletion. The consequences and the reason limit come from
// the server on GetCurrentUser (UserData.accountDeletion); only the wording of
// the confirmation after sending lives here.
// Formats a request time the way the acknowledgement email does (UTC).
export const formatDeletionRequestDate = (requestedAt) => new Date(requestedAt * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
});
// The confirmation shown once a request is sent.
export const deletionRequestOutcome = (res, email) => res.alreadyRequested
    ? `You already asked on ${formatDeletionRequestDate(res.requestedAt)}. We'll be in touch at ${email}.`
    : `Request sent. We'll be in touch at ${email}. Deletion is done by a person, so nothing has been removed yet.`;
